import { createContext } from "react";
import { NotificationManager } from "./notificationManager";

export const NotificationContext = createContext<NotificationManager>(
	new NotificationManager()
);
